import { useState } from "react";
import {
    Button,
    TextField,
    FormControlLabel,
    Checkbox,
    Link,
    Grid,
    Box,
    Typography,
    Container,
    CssBaseline,
    Paper,
} from "@mui/material";
import { postApiCreateVenueOwner, postApiSendOtpEmail, postApiVerifyOtp } from "../../../Core/Apicall";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import louca_logo from "../../../assets/Images/louca_logo.png";
import { UploadImages } from "../../../Core/UploadImages";

export default function Register() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        profileImagePath: ""
    });

    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpVerified, setOtpVerified] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const navigate = useNavigate();

    const handleChange = (e:any) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSendOtp = async () => {
        if (!formData.email) {
            toast.error("Please enter your email");
            return;
        }
        try {
            const res = await postApiSendOtpEmail({ emailId: formData.email })
            console.log(res);
            toast.success("OTP sent to your email!");
            setOtpSent(true);
        } catch (error:any) {
            toast.error(error?.message || "❌ Passwords do not match");

        }
    };

    const handleVerifyOtp = async () => {
        if (!otp) {
            toast.error("Enter the OTP sent to your email");
            return;
        }

        try {
            const payload = {
                otp: otp,
                emailId: formData.email
            };
            const res = await postApiVerifyOtp(payload);
            if (res?.message) {
                toast.success("OTP Verified! You can now set your password.");
                setOtpVerified(true);
            }
        } catch (error:any) {
            toast.error(error?.message || "Something went wrong while verifying OTP. Please try again later");
        }
    };

    const handleImageUpload = async (e:any) => {
        const file = e.target.files[0];
        if (!file) {
            toast.error("Please select an image file first!");
            return;
        }
        try {
            const result = await UploadImages(file, "profile",undefined);
            if (result && result.location) {
                setPreviewImage(result.location);
                setFormData((prev) => ({
                    ...prev,
                    profileImagePath: result.location,
                }));
                toast.success("Profile image uploaded successfully!");
            } else {
                toast.error("Upload failed. Please try again.");
            }
        } catch (error:any) {
            toast.error(error || "Something went wrong while uploading. Please try again later.");
        }
    };

    const handleSubmit = async (e:any) => {
        e.preventDefault();

        if (!otpVerified) {
            toast.warning("⚠️ Please verify your email OTP first!");
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            toast.error("❌ Passwords do not match");
            return;
        }

        try {
            const data = {
                fullName: formData.name,
                emailId: formData.email,
                password: formData.password,
                profileImagePath: formData.profileImagePath,
                role: 5
            };
            const res = await postApiCreateVenueOwner(data);
            toast.success(res?.message || "✅ Registration successful!");
            navigate("/admin/login");
        } catch (error:any) {
            toast.error(error || "Something went wrong. Please try again later.");

        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Paper
                elevation={6}
                sx={{
                    p: 4,
                    mt: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <img src={louca_logo} alt="louca_logo" />
                <Typography component="h1" variant="h5">
                    Register
                </Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    {otpVerified && (
                        <>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="name"
                                label="Full Name"
                                name="name"
                                autoComplete="name"
                                autoFocus
                                value={formData.name}
                                onChange={handleChange}
                                disabled={!otpVerified && otpSent}
                            />


                        </>
                    )}
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={otpSent}
                    />
                    {otpVerified && (
                        <Box sx={{ mt: 2 }}>
                            <Button
                                variant="outlined"
                                component="label"
                                fullWidth
                                sx={{ mb: 2, color: "black", borderColor: "black" }}
                            >
                                Upload Profile Image
                                <input
                                    type="file"
                                    hidden
                                    accept="image/*"
                                    onChange={handleImageUpload}
                                />
                            </Button>
                            {previewImage && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        mb: 2,
                                    }}
                                >
                                    <img
                                        src={previewImage}
                                        alt="Profile Preview"
                                        style={{
                                            width: 80,
                                            height: 80,
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                        }}
                                    />
                                </Box>
                            )}
                        </Box>)}

                    {!otpSent && (
                        <Button
                            fullWidth
                            sx={{ mt: 3, mb: 2, backgroundColor: "black" }}
                            variant="contained"
                            onClick={handleSendOtp}
                        >
                            Send OTP
                        </Button>
                    )}

                    {otpSent && !otpVerified && (
                        <Box sx={{ mt: 2 }}>
                            <TextField
                                fullWidth
                                label="Enter OTP"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, backgroundColor: "black" }}
                                onClick={handleVerifyOtp}
                            >
                                Verify OTP
                            </Button>
                        </Box>
                    )}

                    {otpVerified && (
                        <>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="new-password"
                                value={formData.password}
                                onChange={handleChange}
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="confirmPassword"
                                label="Confirm Password"
                                type="password"
                                id="confirmPassword"
                                autoComplete="new-password"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, backgroundColor: "black" }}
                            >
                                Sign Up
                            </Button>
                        </>
                    )}

                    <Grid container justifyContent="flex-end">
                        <Grid >
                            <Link
                                onClick={() => navigate("/admin/login")}
                                style={{ color: "black", textDecoration: "none", cursor: "pointer" }}
                                variant="body2"
                            >
                                Already have an account? Sign in
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </Container >
    );
}
